import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/dept_center/list',
        method: 'get',
        params: query
    })
}

export function save(data) {
    return request({
        url: '/admin/dept_center/save',
        method: 'post',
        data
    })
}